import { createEffect } from "effector";
import { AuthentifiedUser } from "../../api/backend-openapi";
import configuration from "../../utils/Config";
import { restGetUniqueHandler } from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const userInfoUrl = baseUrl + "/auth/me";

export const requestGetUserInfo = createEffect({
  handler: restGetUniqueHandler<AuthentifiedUser>(userInfoUrl)
});

export const refreshAuthCookie = createEffect({
  handler: restGetUniqueHandler<AuthentifiedUser>(userInfoUrl)
});
